import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, Star } from "lucide-react";
import { fmtMoney, SPACE_TYPE_ICONS } from "../lib/format";
import { EASE_OUT } from "../lib/motion";

// Spatial listing card — flat hairline surface, image drift on hover,
// metadata reveal. Real data only: "New" badge when no genuine reviews.
export default function SpotCard({ spot }) {
  const img = (spot.images || [])[0];
  return (
    <Link to={`/spot/${spot.spot_id}`} data-testid={`spot-card-${spot.spot_id}`} className="block group">
      <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.25, ease: EASE_OUT }}
                  className="card-dark overflow-hidden h-full">
        <div className="h-44 bg-[#050607] relative overflow-hidden">
          {img ? (
            <img src={img} alt={spot.title} loading="lazy"
                 className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-4xl opacity-60" aria-hidden="true">
              {SPACE_TYPE_ICONS[spot.space_type] || "🅿️"}
            </div>
          )}
          <span className="absolute top-3 left-3 text-[10px] font-semibold uppercase tracking-[0.14em] px-2 py-1 rounded-md bg-black/60 backdrop-blur-md border border-white/10 text-zinc-200">{spot.space_type}</span>
        </div>
        <div className="p-4">
          <div className="flex items-start justify-between gap-3">
            <h3 className="font-display font-semibold text-[0.95rem] leading-snug line-clamp-1">{spot.title}</h3>
            {spot.rating != null ? (
              <span className="flex items-center gap-1 text-xs text-amber-400 shrink-0">
                <Star className="w-3.5 h-3.5 fill-amber-400" aria-hidden="true" />
                <span aria-label={`Rated ${spot.rating} from ${spot.review_count} reviews`}>{spot.rating}</span>
              </span>
            ) : (
              <span className="text-[10px] font-semibold px-2 py-0.5 rounded-md bg-[#E50914]/10 text-[#FF3B45] border border-[#E50914]/20 shrink-0" data-testid={`spot-new-badge-${spot.spot_id}`}>New</span>
            )}
          </div>
          <p className="mt-1.5 text-xs text-zinc-500 flex items-center gap-1.5 line-clamp-1">
            <MapPin className="w-3.5 h-3.5 shrink-0" />{spot.address}
          </p>
          <div className="mt-3.5 flex items-center justify-between">
            <p className="font-display font-bold text-[1.05rem] tracking-tight">{fmtMoney(spot.price_per_hour)}<span className="text-xs text-zinc-500 font-body font-normal">/hr</span></p>
            {spot.distance_km != null && <span className="text-xs text-zinc-600">{spot.distance_km} km</span>}
          </div>
          {spot.amenities?.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-1.5">
              {spot.amenities.slice(0, 3).map((a) => (
                <span key={a} className="text-[10px] px-2 py-0.5 rounded-md bg-[#080B0D] border border-[#27272A] text-zinc-500">{a}</span>
              ))}
            </div>
          )}
        </div>
      </motion.div>
    </Link>
  );
}
